/**
 * FairwayBid – Welcher Navigationslink zeigt auf die Seite, auf der man steht?
 *
 * Die Antwort brauchen drei Stellen: die Links direkt in der Kopfzeile, das
 * Ausklappmenü daneben und das Menü auf dem Telefon. Vorher stand dieselbe
 * Rechnung zweimal im Code und in der Kopfzeile gar nicht – deshalb war dort
 * auch nicht zu sehen, wo man gerade ist.
 *
 * "currentPage" ist der Name der aktuellen Route, bei Seiten mit Unterseiten
 * ergänzt um deren Kennung: "CMSPage:fuer-haendler", "InboxPage:orders".
 */
export const isCurrentLink = (routeName, routeParams, currentPage) => {
  if (!currentPage || !routeName) {
    return false;
  }

  const beginntMit = name => currentPage.indexOf(name) === 0;
  const istCMSSeite =
    beginntMit('CMSPage') && currentPage === `${routeName}:${routeParams?.pageId}`;
  const istPosteingang =
    beginntMit('InboxPage') && currentPage === `${routeName}:${routeParams?.tab}`;

  return istCMSSeite || istPosteingang || currentPage === routeName;
};
